<template>
    <b-container class="sign-content-container">
        <b-row>
            <b-col><h1>Style wählen</h1></b-col>
        </b-row>
        <b-row>
            <p>
                Jetzt kannst Du noch den gewünschten Style auswählen, damit unsere Grafiker wissen, wie sie Dich in Szene setzen dürfen.
            </p>
            <p>
                Hinweis: Bitte beachte, dass die angezeigten Bilder nur Musterbilder mit einer anderen Person sind und nur als Beispiel dienen. Wir werden dann das von Dir ausgewählte Bild mit dem von Dir ausgewählten Style bearbeiten.
            </p>
        </b-row>
        <b-row>
            <b-col v-for="style in availableSelection" :key="style.image" cols="6" class="mt-3 image-type-container">
                <p class="style-text"><b v-html="style.title"></b></p>
                <b-img :src="'/' + style.image" fluid class="mb-3"/>
                <b-button :class="selectedStyle === style.style ? 'sf-primary-button': 'sf-primary-button-outline'" @click="setStyle(style.style)">
                    <template v-if="(selectedStyle === style.style)">
                        Ausgewählt
                    </template>
                    <template v-else>
                        Auswählen
                    </template>
                </b-button>
            </b-col>

        </b-row>
        <b-row>
            <b-col class="align-left"><b-button class="sf-secondary-button form-margin" @click="back">Zurück</b-button></b-col>
            <b-col class="align-right"><b-button class="form-margin" :class="selectedStyle ? 'sf-primary-button': ['sf-primary-button-outline','disabled']" @click="next">Weiter</b-button></b-col>
        </b-row>
    </b-container>
</template>

<script>

    export default {
        name: "SignStep3",
        data: () => ({
            styles: [
                {
                    image: 'action_fussball_stadion_dynamic.jpg',
                    section: 'SOCCER',
                    type: 'ACTION',
                    style: 'STADION_DYNAMIC',
                    title: 'Actionbild <br class="d-block d-md-none" />Stadion dynamisch'
                },
                {
                    image: 'action_fussball_stadion.jpg',
                    section: 'SOCCER',
                    type: 'ACTION',
                    style: 'STADION',
                    title: 'Actionbild <br class="d-block d-md-none" />Stadion'
                },
                {
                    image: 'action_fussball_logo.jpg',
                    section: 'SOCCER',
                    type: 'ACTION',
                    style: 'LOGO',
                    title: 'Actionbild <br class="d-block d-md-none" />mit Logo'
                },
                {
                    image: 'action_fussball_nologo.jpg',
                    section: 'SOCCER',
                    type: 'ACTION',
                    style: 'NOLOGO',
                    title: 'Actionbild <br class="d-block d-md-none" />ohne Logo'
                },
                {
                    image: 'action_handball_stadion_dynamic.jpg',
                    section: 'HANDBALL',
                    type: 'ACTION',
                    style: 'STADION_DYNAMIC',
                    title: 'Actionbild <br class="d-block d-md-none" />Stadion dynamisch'
                },
                {
                    image: 'action_handball_stadion.jpg',
                    section: 'HANDBALL',
                    type: 'ACTION',
                    style: 'STADION',
                    title: 'Actionbild <br class="d-block d-md-none" />Stadion'
                },
                {
                    image: 'action_handball_logo.jpg',
                    section: 'HANDBALL',
                    type: 'ACTION',
                    style: 'LOGO',
                    title: 'Actionbild <br class="d-block d-md-none" />mit Logo'
                },
                {
                    image: 'action_handball_nologo.jpg',
                    section: 'HANDBALL',
                    type: 'ACTION',
                    style: 'NOLOGO',
                    title: 'Actionbild <br class="d-block d-md-none" />ohne Logo'
                },
                {
                    image: 'portrait_dynamic.jpg',
                    section: '',
                    type: 'PORTRAIT',
                    style: 'DYNAMIC',
                    title: 'Portraitbild <br class="d-block d-md-none" />dynamisch'
                },
                {
                    image: 'portrait_simple.jpg',
                    section: '',
                    type: 'PORTRAIT',
                    style: 'SIMPLE',
                    title: 'Portaitbild <br class="d-block d-md-none" />normal'
                },
                {
                    image: 'action_karate_logo_dynamic.jpg',
                    section: 'KARATE',
                    type: 'ACTION',
                    style: 'LOGO_DYNAMIC',
                    title: 'Actionbild <br class="d-block d-md-none" />mit Logo dynamisch'
                },
                {
                    image: 'action_karate_dynamic.jpg',
                    section: 'KARATE',
                    type: 'ACTION',
                    style: 'DYNAMIC',
                    title: 'Actionbild <br class="d-block d-md-none" />dynamisch'
                },
                {
                    image: 'action_karate_logo.jpg',
                    section: 'KARATE',
                    type: 'ACTION',
                    style: 'LOGO',
                    title: 'Actionbild <br class="d-block d-md-none" />mit Logo'
                },
                {
                    image: 'action_karate_nologo.jpg',
                    section: 'KARATE',
                    type: 'ACTION',
                    style: 'NOLOGO',
                    title: 'Actionbild <br class="d-block d-md-none" />ohne Logo'
                }
            ],
            selectedStyle: ''
        }),
        props: {
            user: {
                required: true
            }
        },
        computed: {
            availableSelection() {
                return this.styles.filter((element) => {
                    if (this.user.type === 'PORTRAIT') {
                        return element.type === this.user.type
                    }
                    return element.type === this.user.type && element.section === this.user.section
                })
            }
        },
        methods: {
            setStyle(style) {
                this.selectedStyle = style
            },
            next() {
                this.$emit('next', {style: this.selectedStyle})
            },
            back() {
                this.$emit('back')
            }
        },
        created() {
            this.selectedStyle = this.user.style
        }
    }
</script>

<style scoped lang="scss">
.signature {
        display: flex;
        justify-content: center;
        .signature-background {
            display: flex;
            justify-content: center;
            align-items: center;
            position:absolute;

            height: 90px;
            z-index: -100;
            color: lightgray;
            width: 100%;
        }
        .signature-area {
            border: 1px solid lightgray;
        }
    }

    .checkbox-wrapper {
        display: flex;
        justify-content: center;
        div {
            text-align: left;
        }
        /*display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: flex-start;*/
    }

    .reset-button {
        color: #E8C224;
    }

    .no-margin {
        margin: 0;
    }

    .min-form-margin {
        margin-top: 20px;
    }
</style>
